<template>
  <div class="flex flex-col items-center gap-1">
    <!-- Galaxy / constellation marker -->
    <svg width="160" height="32" viewBox="0 0 160 32" fill="none">
      <!-- Decorative stars -->
      <polygon points="10,16 11.5,12 15,11 11.5,10 10,6 8.5,10 5,11 8.5,12" fill="#fbbf24" opacity="0.7" />
      <polygon points="150,16 151.5,12 155,11 151.5,10 150,6 148.5,10 145,11 148.5,12" fill="#fbbf24" opacity="0.7" />
      <!-- Divider lines -->
      <line x1="22" y1="16" x2="58" y2="16" stroke="#a78bfa" stroke-width="1" opacity="0.4" stroke-dasharray="3 3" />
      <line x1="102" y1="16" x2="138" y2="16" stroke="#a78bfa" stroke-width="1" opacity="0.4" stroke-dasharray="3 3" />
      <!-- Center diamond -->
      <polygon points="80,10 84,16 80,22 76,16" fill="#c4b5fd" opacity="0.5" />
    </svg>
    <div class="text-xs font-bold text-violet-200 tracking-wider uppercase px-4 py-1.5 rounded-full bg-violet-900/60 border border-violet-500/30 backdrop-blur-sm shadow-lg shadow-violet-900/20">
      {{ title }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true }
});
</script>
